import React from 'react'
import { Link } from 'react-router-dom'
import Services from '../../api/Services'

import Topimage from '../../images/service/service-bg.jpg'

const ServiceSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(0, 0)
  }

  return (
    <section className={'' + props.hclass}>
      <div className="container-fluid p-0">
        {/* <div className=""> */}
        <h2 className="service-title fade_bottom">New Arrivals</h2>
        {/* </div> */}

        <div className="service-top">
          <div className="image">
            <img src={Topimage} alt="service-bg" />
          </div>
          <div className="content">
            <h2 className="fade_bottom">Discover Our Latest Products</h2>
            <p className="fade_bottom">
              Fresh styles just landed! Be the first to explore our newest collection of carefully curated items.{' '}
            </p>
          </div>
        </div>
        <div className="service-wrap">
          <div className="row">
            {Services.slice(0, 4).map((service, item) => (
              <div className="col-lg-3 col-md-6 col-12 fade_bottom" key={item}>
                <div className="service-card">
                  <div className="icon">
                    <img src={service.Icon} alt="icon" />
                  </div>
                  {/* <h2>
                    <Link
                      onClick={ClickHandler}
                      to={`/service-single/${service.slug}`}
                    >
                      {service.title}
                    </Link>
                  </h2>
                  <p>{service.description}</p> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServiceSection
